import { useRef, useState } from "react";
import { Item, Submenu } from "react-contexify";
import { useTranslation } from 'react-i18next';
import { LuLoader } from "react-icons/lu";
import "../style/ReactContexify.css";

const SEARCH_PLACES = [
    { name: "Youtube", url: "https://www.youtube.com/results?search_query=" },
    { name: "Wikipedia", url: "https://en.wikipedia.org/wiki/Special:Search?search=" },
    { name: "Google", url: "https://www.google.com/search?q=" },
    { name: "Google Scholar", url: "https://scholar.google.com/scholar?q=" },
    { name: "Reddit", url: "https://www.reddit.com/search/?q=" },
    { name: "Bing", url: "https://www.bing.com/search?q=" },
    { name: "DuckDuckGo", url: "https://duckduckgo.com/?q=" },
    { name: "Yahoo", url: "https://search.yahoo.com/search?p=" },
];

const SubmenuSearchAbout = ({ getSearchQuery }) => {
    const { t } = useTranslation();
    const [query, setQuery] = useState(null);
    const fetchedRef = useRef(false);

    const handleOpen = () => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        getSearchQuery().then(q => setQuery(q?.replace(/"/g, '')));
    };

    return (
        <Submenu label={<span onMouseEnter={handleOpen}>{t('search.searchAboutOn')}</span>}>
            {SEARCH_PLACES.map((place) => (
                <Item key={place.name} onClick={() => query && window.open(place.url + encodeURIComponent(query), "_blank")} disabled={!query}>
                    {!query && <span className="rotating" style={{ marginRight: 6, display: 'inline-flex' }}><LuLoader style={{ fontSize: 12 }} /></span>}
                    {place.name}
                </Item>
            ))}
        </Submenu>
    );
};


export default SubmenuSearchAbout
